import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { planPriorityBadge } from '@/lib/todaysPlanUtils';
import { useTranslation } from '@/components/utils/translations';

export default function PlanPriorityBadge({ item, className = '' }) {
  const { t } = useTranslation();
  const i = planPriorityBadge(item, t);
  const drivers = Array.isArray(item?.priorityDrivers)
    ? item.priorityDrivers.filter((d) => d != null && String(d).trim() !== '')
    : [];

  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span tabIndex={0} className="inline-flex cursor-help">
            <Badge className={`${i.color} text-xs h-5 ${className}`.trim()}>
              {i.label}
            </Badge>
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-xs bg-[#0A1A2F] text-white border-0 shadow-lg px-3 py-2">
          <p className="font-medium leading-snug">{t('priorityTooltipLead')}</p>
          {drivers.length > 0 ? (
            <ul className="mt-1.5 space-y-0.5 text-[11px] leading-snug font-normal">
              {drivers.map((driver, idx) => (
                <li key={`${idx}-${driver}`}>{driver}</li>
              ))}
            </ul>
          ) : null}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
